/* eslint-disable */

//import * as db from "db.js";

export interface IObjectStore<K, T> {
    add(...items: Array<T>): Promise<Array<T>>;
    clear(): Promise<void>;
    get(key: K): Promise<Array<T>>;
    query(): IObjectStoreQuery<K, T>;
    query<K>(indexName: string): IObjectStoreIndexQuery<K, T>;
    remove(key: K): Promise<T>;
    update(...items: Array<T>): Promise<T>;
}

export interface IObjectStoreQuery<K, T> {
    all(): IQueryClause<K, T>;
    filter(key: K, value: T): IQueryClause<K, T>;
    filter(filterFunc: (item: T) => T): IQueryClause<K, T>;
}

export interface IObjectStoreIndexQuery<K, T> {
    all(): IIndexQueryClause<K, T>;
    bound(lower: K, upper: K, lowerOpen?: boolean, upperOpen?: boolean): IIndexQueryClause<K, T>;
    filter(key: K, value: T): IIndexQueryClause<K, T>;
    filter(filterFunc: (item: T) => T): IIndexQueryClause<K, T>;
    lowerBound(bound: K, open?: boolean): IIndexQueryClause<K, T>;
    only(key: K): IIndexQueryClause<K, T>;
    upperBound(bound: K, open?: boolean): IIndexQueryClause<K, T>;
}

export interface IExecute<T> {
    execute(): Promise<Array<T>>;
}

export interface IQueryClause<K, T> extends IExecute<T> {
    desc(): IDescClause<K, T>;
    distinct(): IDistinctClause<K, T>;
    filter(key: K, value: T): IFilterClause<K, T>;
    filter(filterFunc: (item: T) => T): IFilterClause<K, T>;
    limit(skip: number, take: number): IExecute<T>;
    map(mapFunc: (item: T) => T): IMapClause<K, T>;
    modify(changes: { [key: string]: any | ((modifyFunc: any) => any) }): IExecute<T>;
}

export interface IIndexQueryClause<K, T> extends IExecute<T> {
    desc(): IDescClause<K, T>;
    distinct(): IDistinctClause<K, T>;
    filter(key: K, value: T): IFilterClause<K, T>;
    filter(filterFunc: (item: T) => T): IFilterClause<K, T>;
    keys(): IKeysClause<K, K>;
    limit(skip: number, take: number): IExecute<T>;
    map(mapFunc: (item: T) => T): IMapClause<K, T>;
    modify(changes: { [key: string]: any | ((modifyFunc: any) => any) }): IExecute<T>;
}

export interface IDescClause<K, T> extends IExecute<T> {
    distinct(): IDistinctClause<K, T>;
    filter(key: K, value: T): IFilterClause<K, T>;
    filter(filterFunc: (item: T) => T): IFilterClause<K, T>;
    map(mapFunc: (item: T) => T): IMapClause<K, T>;
    modify(changes: { [key: string]: any | ((modifyFunc: any) => any) }): IExecute<T>;
}

export interface IIndexDescClause<K, T> extends IDescClause<K, T> {
    keys(): IKeysClause<K, T>;
}

export interface IDistinctClause<K, T> extends IExecute<T> {
    count(): IExecute<T>;
    desc(): IDistinctClause<K, T>;
    filter(key: K, value: T): IFilterClause<K, T>;
    filter(filterFunc: (item: T) => T): IFilterClause<K, T>;
    map(mapFunc: (item: T) => T): IMapClause<K, T>;
    modify(changes: { [key: string]: any | ((modifyFunc: any) => any) }): IExecute<T>;
}

export interface IIndexDistinctClause<K, T> extends IDistinctClause<K, T> {
    keys(): IKeysClause<K, K>;
}

export interface IFilterClause<K, T> extends IExecute<T> {
    desc(): IDescClause<K, T>;
    distinct(): IDistinctClause<K, T>;
    filter(key: K, value: T): IFilterClause<K, T>;
    filter(filterFunc: (item: T) => T): IFilterClause<K, T>;
    limit(skip: number, take: number): IExecute<T>;
    map(mapFunc: (item: T) => T): IMapClause<K, T>;
    modify(changes: { [key: string]: any | ((modifyFunc: any) => any) }): IExecute<T>;
}

export interface IIndexFilterClause<K, T> extends IFilterClause<K, T> {
    keys(): IKeysClause<K, K>;
}

export interface IKeysClause<K, T> extends IExecute<T> {
    desc(): IDescClause<K, T>;
    distinct(): IDistinctClause<K, T>;
    filter(key: K, value: T): IFilterClause<K, T>;
    filter(filterFunc: (item: T) => T): IFilterClause<K, T>;
    map(mapFunc: (item: T) => T): IMapClause<K, T>;
}

export interface IMapClause<K, T> extends IExecute<T> {
    count(): IExecute<T>;
    desc(): IDescClause<K, T>;
    distinct(): IDistinctClause<K, T>;
    filter(key: K, value: T): IFilterClause<K, T>;
    filter(filterFunc: (item: T) => T): IFilterClause<K, T>;
    limit(skip: number, take: number): IExecute<T>;
    map(mapFunc: (item: T) => T): IMapClause<K, T>;
    modify(changes: { [key: string]: any | ((modifyFunc: any) => any) }): IExecute<T>;
}

export interface IIndexMapClause<K, T> extends IMapClause<K, T> {
    keys(): IKeysClause<K, K>;
}

export interface IObjectStoreSchema {
    key: {
        keyPath: string;
        autoIncrement?: boolean;
    };
    indexes?: {
        [key: string]: any;
    };
}

export interface IDatabaseOptions {
    database: string;
    version: number;
    schema?: {
        [key: string]: IObjectStoreSchema;
    };
}

export interface IDatabase {
    close(): void;
    objectStore<K, T>(name: string): IObjectStore<K, T>;
}

// export interface IDatabaseFactory {
//     indexedDB: IDBFactory;
//     open(options: IDatabaseOptions): Promise<IDatabase>;
//     deleteDatabase(name: string): Promise<void>;
// }


export interface IStorage {
    get<T>(key: string, initialValue: T): T;
    set<T>(key: string, value: T): void;
    remove(key: string | string[]): void;
    clear(): void;
}


export interface IStorageService {
    local: IStorage;
    session: IStorage;
    //database: IDatabaseFactory;
}

// class DatabaseFactory implements IDatabaseFactory {
//     constructor(private _indexedDB: IDBFactory) {}

//     public get indexedDB(): IDBFactory {
//         return this._indexedDB;
//     }

//     public open(options: any): Promise<IDatabase> {
//         return new Promise((resolve: (server: Database) => void, reject: (error: any) => void) => {
//             try {
//                 db.open({
//                     server: options.database,
//                     version: options.version,
//                     schema: options.schema
//                 }).then(
//                 (server) => {
//                     resolve(new Database(server));
//                 },
//                 (error) => {
//                     reject(error);
//                 });
//             } catch (e) {
//                 reject(e);
//             }
//         });
//     }

//     public deleteDatabase(name: string): Promise<void> {
//         return new Promise<void>((resolve: (value?: void) => void, reject: (reason?: any) => void) => {
//             try {
//                 const request = this._indexedDB.deleteDatabase(name);
//                 request.onsuccess = function (event: Event) {
//                     resolve();
//                 };
//                 request.onerror = function(event: Event) {
//                     reject();
//                 };
//             } catch (e) {
//                 reject();
//             }
//         });
//     }
// }

// class Database implements IDatabase {
//     constructor(private _server: any) {}

//     public close(): void {
//         this._server.close();
//     }

//     public objectStore<K, T>(name: string): IObjectStore<K, T> {
//         if (this._server.hasOwnProperty(name)) {
//             return new ObjectStore<K, T>(this._server[name]);
//         } else {
//             throw new Error("Object store not found");
//         }
//     }
// }

// class ObjectStore<K, T> implements IObjectStore<K, T> {
//     public constructor(private _server: any) {}

//     public add(...items: Array<T>): Promise<Array<T>> {
//         return this._server.add.apply(this, items);
//     }

//     public clear(): Promise<void> {
//         return this._server.clear();
//     }

//     public get(key: K): Promise<Array<T>> {
//         return this._server.get(key);
//     }

//     public query(): IObjectStoreQuery<K, T>;
//     public query<K>(indexName: string): IObjectStoreIndexQuery<K, T>;
//     public query(indexName?: string): any {
//         return indexName ? new ObjectStoreIndexQuery<K, T>(this._server.query(indexName)) : new ObjectStoreQuery<K, T>(this._server.query());
//     }

//     public remove(key: K): Promise<T> {
//         return this._server.remove(key);
//     }

//     public update(...items: Array<T>): Promise<T> {
//         return this._server.update.apply(this, items);
//     }
// }

// class ObjectStoreQuery<K, T> implements IObjectStoreQuery<K, T> {
//     public constructor(private _indexQuery: any) {}

//     public all(): IQueryClause<K, T> {
//         return this._indexQuery.all();
//     }

//     public filter(key: K, value: T): IQueryClause<K, T>;
//     public filter(filterFunc: (item: T) => any): IQueryClause<K, T>;
//     public filter(keyOrfilterFunc: K | ((item: T) => any), value?: T): IQueryClause<K, T> {
//         return this._indexQuery.filter(keyOrfilterFunc, value);
//     }
// }

// class ObjectStoreIndexQuery<K, T> implements IObjectStoreIndexQuery<K, T> {
//     public constructor(private _indexQuery: any) {}

//     public all(): IIndexQueryClause<K, T> {
//         return this._indexQuery.all();
//     }

//     public filter(key: K, value: T): IIndexQueryClause<K, T>;
//     public filter(filterFunc: (item: T) => any): IIndexQueryClause<K, T>;
//     public filter(keyOrfilterFunc: K | ((item: T) => any), value?: T): IIndexQueryClause<K, T> {
//         return this._indexQuery.filter(keyOrfilterFunc, value);
//     }

//     public bound(lower: K, upper: K, lowerOpen?: boolean, upperOpen?: boolean): IIndexQueryClause<K, T> {
//         return this._indexQuery.bound(lower, upper, lowerOpen, upperOpen);
//     }

//     public lowerBound(bound: K, open?: boolean): IIndexQueryClause<K, T> {
//         return this._indexQuery.lowerBound(bound, open);
//     }

//     public only(key: K): IIndexQueryClause<K, T> {
//         return this._indexQuery.only(key);
//     }

//     public upperBound(bound: K, open?: boolean): IIndexQueryClause<K, T> {
//         return this._indexQuery.upperBound(bound, open);
//     }
// }

class StorageService implements IStorageService {
    private _localStorage: TStorage;
    private _sessionStorage: TStorage;
    //private _databaseFactory: DatabaseFactory;

    constructor(localStorage: Storage, 
        sessionStorage: Storage 
        /* indexedDB: IDBFactory*/) {
        this._localStorage = new TStorage(localStorage);
        this._sessionStorage = new TStorage(sessionStorage);
        //this._databaseFactory = new DatabaseFactory(indexedDB);
    }

    public get local(): IStorage {
        return this._localStorage;
    }

    public get session(): IStorage {
        return this._sessionStorage;
    }

    //public get database(): IDatabaseFactory {
       //return this._databaseFactory;
    //}
}

class TStorage implements IStorage {
    constructor(private _storage: Storage) {

    }

    public get<T>(key: string, initialValue: T): T {
        try {
            const item = this._storage.getItem(key);
            // Parse stored json or if none return initialValue
            return item ? typeof(initialValue) === 'string' ? item as T  : JSON.parse(item) : initialValue;
        } catch (error) {
        //console.log(error);
        return initialValue;
        }
    }

    public set<T>(key: string, value: T): void {
        try {
            this._storage.setItem(key, typeof(value) === 'number' || typeof(value) === 'string' || typeof(value) === 'boolean'  ? value.toString() : JSON.stringify(value));
          } catch (error) {
            console.log(error);
          }
    }

    public remove(key: string | string[]): void {
        try {
            if (typeof key === 'object') {
              const keys = key as string[];
              keys.forEach((value) => {
                this._storage.removeItem(value);            
              })
            } else {
                this._storage.removeItem(key);
            }
          } catch (error) {
            console.log(error);
          }
    }

    public clear(): void {
        this._storage.clear();
    }
}

const storageService = new StorageService(window.localStorage, window.sessionStorage);
export default storageService;
